import { Component, effect, inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { InternalFilterGroup, FilterItem } from 'app/shared/models/filter-group.models';
import { SearchSettings } from 'app/back-office/shared/models/common/search-settings.model';
import { ShopContextStore } from 'app/shared/state/shop-context.store';
import { FilterMapper } from 'app/back-office/shared/utilities/filter-mapper';
import { UtilityFunctions } from 'app/shared/utilities/functions.models';

@Component({
    selector: 'app-online-store-filter',
    templateUrl: './online-store-filter.component.html',
    styleUrls: ['./online-store-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OnlineStoreFilterComponent {
  @Input() filter: InternalFilterGroup;
  loaderId = UtilityFunctions.newGuid();

  searchSettings: SearchSettings = {
    placeholder: 'Search shop...',
    inputId: UtilityFunctions.newGuid(),
    showFilters: false,
  };

  totalCount = 0;
  searchValue = '';
  cacheFilterData: FilterItem[];
  dataToView: FilterItem[] = [];

  private _shopContext = inject(ShopContextStore);

  constructor() {
    // Era un subscribe su shops in ngOnInit: stessa logica, ora al flush.
    effect(() => {
      const res = this._shopContext.shops();
      this.cacheFilterData = [new FilterItem({ text: 'STATUS.ALL', value: null }), ...res.map(el => FilterMapper.OnlineStoreFilter(el))];
      if (this.filter.isNotShowOptionAll) this.cacheFilterData.shift();
      this.totalCount = res.length;
      this.setDataToView(0);
    });
  }


  onSearch(search: string) {
    this.searchValue = search;
    this.setDataToView(0);
  }

  setDataToView(startSlice: number) {
    const dataToSlice = this.cacheFilterData.filter(element => {
      let isMatch = true;
      if (this.searchValue) {
        const search = this.searchValue.toLowerCase();
        isMatch = element.text?.toLowerCase().indexOf(search) >= 0;
      }
      // More filters
      return isMatch;
    });
    if (this.filter.withPagination) {
      const dataToView = dataToSlice.slice(startSlice, startSlice + 10);
      this.dataToView = dataToView;
    } else {
      this.dataToView = dataToSlice;
    }
  }

  getNextData(skipCount: number) {
    if (this.totalCount > skipCount) {
      this.setDataToView(skipCount);
    }
  }

}
